module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/244.bf2d15ba.png";